<template>
  <div
    class="pt-5 page-header align-items-start min-vh-50 pb-11 row"
    style="background: rgb(81,112,255); background: linear-gradient(135deg, rgba(81,112,255,1) 0%, rgba(203,12,159,1) 100%); -webkit-mask: linear-gradient(white 75%, transparent);"
    
  >
    <span class="bg-gradient-dark opacity-6"></span>
    <div class="container">
      <div class="row justify-content-center">
        <div class="mx-auto text-center col-lg-5">
          <img src="../assets/img/ToMate.png" alt="main_logo" style=" z-index: 1099; height: 220px; margin: -60px 0px -35px 0px;"/>
          <h1 class="mb-2 text-white">Plans</h1>
          <p class="text-white text-lead" style="padding: 0 5px;">
            Choose the perfect plan to suit your needs and budget
          </p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="mb-4 mx-auto col-xl-4 col-lg-12 col-md-12 d-flex flex-column"> 
            <div class="container" style="width: fit-content;">
              <div class="card z-index-0" style="min-width: 349px">
              <!--<img src="../assets/img/logo-ToMate.png" class="navbar-brand-img h-100" alt="main_logo" style="opacity: 0.8; margin: -140px 0;"/>-->
              <div class="pb-0 card-header text-start" style="margin-bottom: -15px;">
                  <span style="background-color: #efefef;
                    padding: 2px 10px;
                    border-radius: 30px;
                    border: #cccccc 1px solid;">
                    Starter
                  </span>    
              </div>
              <div class="card-body">
                <div class="mb-1" style="display: flex; align-items: baseline; gap: 3px;">
                  <h1 class="font-weight-bolder mb-0">
                    25
                  </h1>
                  <sub>USD/month</sub>
                </div>
                <div class="mb-2">
                  <p class="mb-0">Up to 700 mails per month.</p>
                  <p class="mb-0">0.0285 USD per mail.</p>
                </div>
                <div class="mb-2 text-center">
                  <soft-button
                    @click="choosePlan('STARTER')"
                    class="mb-2"
                    color="success"
                    full-width
                    >Choose plan
                  </soft-button>
                </div>

                <div class="mb-3">
                  <div style="display: grid; gap: 10px;">
                    <div>
                      <img src="../assets/img/bullet.png" height="25" /> Up to 700 mails per month
                    </div>
                    <div>
                      <img src="../assets/img/bullet.png" height="25" /> Up to 5 users
                    </div>
                    <div>
                      <img src="../assets/img/bullet.png" height="25"  /> 10000 mails' storage
                    </div>
                    <div>
                      <img src="../assets/img/bullet.png" height="25" /> 5 documents
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          
        <div class="mb-4 mx-auto col-xl-4 col-lg-12 col-md-12 d-flex flex-column"> 
            <div class="container" style="width: fit-content;">
              <div class="card z-index-0" style="min-width: 349px">
              <!--<img src="../assets/img/logo-ToMate.png" class="navbar-brand-img h-100" alt="main_logo" style="opacity: 0.8; margin: -140px 0;"/>-->
              <div class="pb-0 card-header text-start" style="margin-bottom: -15px;">
                  <span style="background-color: #efefef;
                    padding: 2px 10px;
                    border-radius: 30px;
                    border: #cccccc 1px solid;">
                    Advanced
                  </span>    
              </div>
              <div class="card-body">
                <div class="mb-1" style="display: flex; align-items: baseline; gap: 3px;">
                  <h1 class="font-weight-bolder mb-0">
                    90
                  </h1>
                  <sub>USD/month</sub>
                </div>
                <div class="mb-2">
                  <p class="mb-0">Up to 3500 mails per month.</p>
                  <p class="mb-0">0.0257 USD per mail.</p>
                </div>
                <div class="mb-2 text-center">
                  <soft-button
                    @click="choosePlan('ADVANCED')"
                    class="mb-2"
                    color="success"
                    full-width
                    >Choose plan
                  </soft-button>
                </div>

                <div class="mb-3">
                  <div style="display: grid; gap: 10px;">
                    <div>
                      <img src="../assets/img/bullet.png" height="25" /> Up to 3500 mails per month
                    </div>
                    <div>
                      <img src="../assets/img/bullet.png" height="25" /> Up to 10 users
                    </div>
                    <div>
                      <img src="../assets/img/bullet.png" height="25"  /> 50000 mails' storage
                    </div>
                    <div>
                      <img src="../assets/img/bullet.png" height="25" /> 20 documents
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          
        <div class="mb-4 mx-auto col-xl-4 col-lg-12 col-md-12 d-flex flex-column">
            <div class="container" style="width: fit-content;">
              <div class="card z-index-0" style="min-width: 349px">
              <!--<img src="../assets/img/logo-ToMate.png" class="navbar-brand-img h-100" alt="main_logo" style="opacity: 0.8; margin: -140px 0;"/>-->
              <div class="pb-0 card-header text-start" style="margin-bottom: -15px;">
                  <span style="background-color: #efefef;
                    padding: 2px 10px;
                    border-radius: 30px;
                    border: #cccccc 1px solid;">
                    Premium
                  </span>    
              </div>
              <div class="card-body">
                <div class="mb-1" style="display: flex; align-items: baseline; gap: 3px;">
                  <h1 class="font-weight-bolder mb-0">
                    210
                  </h1>
                  <sub>USD/month</sub>
                </div>
                <div class="mb-2">
                  <p class="mb-0">Up to 8500 mails per month.</p>
                  <p class="mb-0">0.0247 USD per mail.</p>
                </div>
                <div class="mb-2 text-center">
                  <soft-button
                    @click="choosePlan('PREMIUM')"
                    class="mb-2"
                    color="success"
                    full-width
                    >Choose plan
                  </soft-button>
                </div>

                <div class="mb-3">
                  <div style="display: grid; gap: 10px;">
                    <div>
                      <img src="../assets/img/bullet.png" height="25" /> Up to 8500 mails per month
                    </div>
                    <div>
                      <img src="../assets/img/bullet.png" height="25" /> Up to 30 users
                    </div>
                    <div>
                      <img src="../assets/img/bullet.png" height="25"  /> 100000 mails' storage
                    </div>
                    <div>
                      <img src="../assets/img/bullet.png" height="25" /> 50 documents
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;
    justify-content: center;
    padding-top: 25px;">
        <soft-button
          @click="goToPlatform()"
          class="mb-2 success"
          >Back to platform
        </soft-button>
      </div>
    </div>
        
  </div>
  
  <app-footer />
</template>

<script>
import AppFooter from "@/examples/PageLayout/Footer.vue";
import SoftButton from "@/components/SoftButton.vue";
import { mapMutations } from "vuex";
import HTFetch from "../llamadas/HTFetch"
import K from "../llamadas/K"
import router from '../router/index'

export default {
  name: "Paquetes",
  components: {
    AppFooter,
    SoftButton
  },

  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },

  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },

  data() {
    return {
      password: "",
      llamada: new HTFetch(),
      K: new K(),
      wrongCreds: false,
      new_password1: "",
      new_password2: ""
    }
  },
 
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    choosePlan(membership) {

      if (this.$gtm.enabled()) {
        if (membership === 'STARTER') {
          window.dataLayer?.push({
            event: "starter",
            user_id: localStorage.userId
          }); 
        }
        if (membership === 'PREMIUM') {
          window.dataLayer?.push({
            event: "premium",
            user_id: localStorage.userId
          }); 
        }
        if (membership === 'ADVANCED') {
          window.dataLayer?.push({
            event: "advanced",
            user_id: localStorage.userId
          }); 
        }
      }

      this.llamada.stripeCheckout(membership, this.choosePlanRsp.bind(this))
    },

    choosePlanRsp(rsp) {
      
      window.open(rsp.data.url)
    },

    goToPlatform() {
      router.push({ name: 'Sign In'})
    }
  },
};
</script>
<style scoped>
@media (max-width: 1200px) {
  .container {
    padding: 0px;
  }
}
</style>
